export default[
    {
        path: '/boletins/cartaoponto/trabalhadores/cadastro/:id',
        name: 'cadastro', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/boletins/cartaoponto/trabalhadores/lista/:id',
        name: 'lista', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/boletins/cartaoponto/trabalhadores/editar/:boletim_id/:id',
        name: 'editar', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]